(()=>{
  'use strict';
  if (window.URACardViewers) return;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const normalize = value => String(value || '').trim().toLowerCase();
  const cardViewerInstances = new Map();
  const hoverInput = matchMedia('(hover: hover) and (pointer: fine)');
  const mobileInput = matchMedia('(max-width: 760px), (hover: none), (pointer: coarse)');
  const nativeTouchInput = matchMedia('(any-pointer: coarse), (hover: none)');
  let closeActiveTechnology = null;
  document.addEventListener('keydown',event => { if (event.key === 'Escape') closeActiveTechnology?.(); });
  let previewId = 0;
  const initCardViewers = catalog => {
    cardViewerInstances.forEach((destroy, node) => { if (!node.isConnected) destroy(); });
    const viewers = [...catalog.querySelectorAll('[data-card-viewer]')];
    if (catalog.matches?.('[data-card-viewer]')) viewers.unshift(catalog);
    viewers.forEach(viewer => {
      if (cardViewerInstances.has(viewer) || !viewer.closest('[data-ura2-catalog], .ura-shopping-arrivals')) return;
      const card = viewer.closest('[data-ura2-card], [data-ura-preview-card]');
      const image = viewer.querySelector('.ura2-product-card__image--primary, [data-card-primary]');
      const link = viewer.querySelector('[data-card-link]');
      const stage = viewer.querySelector('[data-card-stage]') || link;
      const data = viewer.querySelector('[data-card-images]');
      const controls = viewer.querySelector('[data-card-controls]');
      const counter = viewer.querySelector('[data-card-counter]');
      if (!card || !image || !link || !data || !controls || !counter) return;
      let parsed;
      try { parsed = JSON.parse(data.textContent).filter(item => item && item.url); } catch { return; }
      const colorKey = value => normalize(value).replace(/\s+/g, ' ');
      const idKey = value => String(value || '').split('/').pop();
      const imageBase = document.baseURI || location.href;
      const sourceKey = value => {
        try { const url = new URL(value, imageBase); return url.origin + url.pathname; }
        catch { return String(value); }
      };
      const swatches = [...card.querySelectorAll('[data-card-color]')];
      const colors = [...new Set(swatches.map(s => colorKey(s.dataset.cardColor)).filter(Boolean))].sort((a,b) => b.length-a.length);
      const heroColor = colorKey(viewer.dataset.cardHeroColor);
      const images = [], byId = new Map(), bySource = new Map();
      parsed.forEach(item => {
        const id = idKey(item.id), source = sourceKey(item.url);
        const existing = (id && byId.get(id)) || bySource.get(source);
        if (existing) {
          if (id) { existing.aliases.add(id); byId.set(id, existing); }
          existing.cover = existing.cover || item.cover;
          existing.studio = existing.studio || item.studio;
          if (!existing.role && item.role) existing.role = item.role;
          if (!existing.color && item.color) existing.color = item.color;
          return;
        }
        const entry = {...item, aliases: new Set(id ? [id] : [])};
        images.push(entry); if (id) byId.set(id, entry); bySource.set(source, entry);
      });
      if (!images.length) return;
      const matchesId = (item, id) => Boolean(idKey(id) && item.aliases.has(idKey(id)));
      const indexById = id => images.findIndex(item => matchesId(item, id));
      const photoColor = item => {
        if (item.color) return colorKey(item.color);
        const swatch = swatches.find(s => matchesId(item, s.dataset.cardColorImage));
        if (swatch) return colorKey(swatch.dataset.cardColor);
        const text = colorKey(item.alt).replace(/[^\p{L}\p{N}\s]/gu, ' ');
        const explicit = colors.find(c => (' '+text+' ').includes(' '+c+' '));
        if (explicit) return explicit;
        return colors.length === 1 ? colors[0] : '';
      };
      const isBack = item => (item.role === 'back' || item.role === 'opposite') && Boolean(item.color);
      const backIndex = color => color ? images.findIndex(item => isBack(item) && photoColor(item) === color) : -1;
      const coverIndex = images.findIndex(item => item.cover);
      if (coverIndex > 0) images.unshift(images.splice(coverIndex, 1)[0]);
      // Reorder only the card, never the product's shared gallery or color-photo map.
      const firstBack = backIndex(heroColor || photoColor(images[0]));
      if (firstBack > 1) images.splice(1, 0, images.splice(firstBack, 1)[0]);

      if (images.length > 8) {
        const preview = [];
        const addPreview = item => { if (item && !preview.includes(item)) preview.push(item); };
        addPreview(images[0]);
        if (images[1]) addPreview(images[1]);
        swatches.forEach(s => addPreview(images.find(item => matchesId(item,s.dataset.cardColorImage))));
        if (viewer.dataset.cardPairedColors === 'true') {
          preview.length = 0;
          swatches.forEach(s => {
            const lead = images.find(item => matchesId(item,s.dataset.cardColorImage));
            addPreview(lead);
            addPreview(images.find(item => isBack(item) && photoColor(item) === colorKey(s.dataset.cardColor)));
          });
        }
        images.filter(item => item.studio).forEach(addPreview);
        images.filter(item => !item.linked).forEach(addPreview);
        images.forEach(addPreview);
        images.splice(0,images.length,...preview);
      }

      const abort = new AbortController(), signal = abort.signal;
      const on = (node, type, listener, options = {}) => node?.addEventListener(type, listener, {...options, signal});
      const prev = viewer.querySelector('[data-card-previous]'), next = viewer.querySelector('[data-card-next]');
      const feedback = viewer.querySelector('[data-card-status]');
      const fallback = viewer.querySelector('[data-card-fallback]');
      const colorName = card.querySelector('[data-card-color-name]');
      const progress = viewer.querySelector('[data-card-progress]');
      const direction = getComputedStyle(viewer).direction === 'rtl' ? -1 : 1;
      viewer.dataset.cardPreview = 'unified';
      controls.className = 'ura-card-preview-controls';
      controls.setAttribute('data-ura-swap-host','unified-preview');
      let index = 0, requestedIndex = 0, token = 0, start = null, suppressClickUntil = 0;
      let hoverTimer = 0, hoverOrigin = null, manualSession = false, disposed = false;
      let recovering = false, touchInput = false;
      let nativeTrack = null, nativePhotos = [], nativeMode = false, nativeStart = null, nativeScrollFrame = 0;
      let ensureNative = () => {}, syncNative = () => {};
      const originalDescription = link.getAttribute('aria-describedby');
      const originalTabStops = [prev,next].map(button => button?.getAttribute('tabindex'));
      const indicator = document.createElement('span');
      indicator.className = 'ura-card-preview__position';
      indicator.setAttribute('aria-hidden','true');
      const dots = Array.from({length:Math.min(images.length,5)},() => {
        const dot = document.createElement('span');
        indicator.appendChild(dot);
        return dot;
      });
      indicator.hidden = images.length < 2;
      stage.appendChild(indicator);
      const help = document.createElement('span');
      help.className = 'ura-card-preview-status';
      help.id = 'ura-card-preview-help-'+(++previewId);
      const locale = (document.documentElement?.lang || 'en').split('-')[0];
      help.textContent = locale === 'ar' ? 'اسحب يمينًا أو يسارًا لعرض المزيد من الصور. استخدم مفاتيح الأسهم عند استخدام لوحة المفاتيح.' : locale === 'es' ? 'Desliza a la izquierda o a la derecha para ver más fotos. Con el teclado, usa las flechas.' : 'Swipe left or right for more photos. With a keyboard, use the arrow keys.';
      const technology = stage.querySelector('[data-card-tech-reveal]');
      const technologySlot = card.querySelector('.ura-card-signature');
      if (technology) help.textContent += ' ' + technology.dataset.cardTechDescription;
      if (images.length > 1 || technology) {
        viewer.appendChild(help);
        link.setAttribute('aria-describedby',[originalDescription,help.id].filter(Boolean).join(' '));
      }
      const syncInput = () => {
        const mobile = mobileInput.matches || touchInput;
        if (mobile) viewer.setAttribute('data-card-swipe-only','');
        else viewer.removeAttribute('data-card-swipe-only');
        [prev,next].forEach((button,i) => {
          if (!button) return;
          if (mobile) button.setAttribute('tabindex','-1');
          else if (originalTabStops[i] === null) button.removeAttribute('tabindex');
          else button.setAttribute('tabindex',originalTabStops[i]);
        });
      };
      syncInput();
      const sizeControls = () => {
        if (stage.clientHeight) viewer.style.setProperty('--ura-card-media-height',stage.clientHeight+'px');
        if (nativeTrack) syncNative(index);
      };
      let sizeObserver;
      if ('ResizeObserver' in window) {
        sizeObserver = new ResizeObserver(sizeControls);
        sizeObserver.observe(stage);
      }
      sizeControls();
      on(window,'resize',sizeControls,{passive:true});
      let transitionImage = null, transitionAnimation = null;
      const clearTransition = () => { transitionAnimation?.cancel(); transitionAnimation = null; transitionImage?.remove(); transitionImage = null; };
      let selectedColor = heroColor || photoColor(images[0]);
      const widths = [320,480,640,900,1200], loads = new Map(), timers = new Set();
      const sized = (src, width) => { const url = new URL(src, imageBase); url.searchParams.set('width', String(width)); return url.href; };
      const update = () => {
        controls.hidden = images.length < 2;
        const formatFrame = value => String(value).padStart(2,'0');
        counter.textContent = formatFrame(index+1)+' / '+formatFrame(images.length);
        const firstDot = Math.max(0,Math.min(index-2,images.length-dots.length));
        dots.forEach((dot,i) => {
          const photoIndex = firstDot+i;
          dot.dataset.cardPhotoIndex = String(photoIndex);
          if (photoIndex === index) dot.setAttribute('data-current','');
          else dot.removeAttribute('data-current');
          if ((i === 0 && firstDot > 0) || (i === dots.length-1 && photoIndex < images.length-1)) dot.setAttribute('data-edge','');
          else dot.removeAttribute('data-edge');
        });
        if (progress) progress.style.width = ((index+1)/images.length*100)+'%';
      };
      const markColor = (color, updateLinks = false) => {
        if (!color) return;
        selectedColor = color;
        const active = swatches.find(s => colorKey(s.dataset.cardColor) === color);
        swatches.forEach(s => s === active ? s.setAttribute('aria-current','true') : s.removeAttribute('aria-current'));
        if (colorName) colorName.textContent = active?.title || active?.dataset.cardColor || '';
        if (active?.hidden) {
          card.querySelectorAll('[data-card-extra-color]').forEach(s => { s.hidden = false; });
          const more = card.querySelector('[data-card-more-colors]');
          if (more) { more.hidden = true; more.setAttribute('aria-expanded','true'); }
        }
        if (updateLinks && active) card.querySelectorAll('[data-card-link],.ura2-product-card__info h2 a').forEach(a => { a.href = active.href; });
      };
      const loadImage = item => {
        if (loads.has(item.url)) return loads.get(item.url);
        const pending = new Promise((resolve, reject) => {
          const preload = new Image(); let finished = false;
          const finish = ok => {
            if (finished) return; finished = true;
            clearTimeout(timer); timers.delete(timer); preload.onload = null; preload.onerror = null;
            if (ok) {
              (preload.decode ? preload.decode().catch(() => {}) : Promise.resolve()).then(() => resolve(preload));
            } else reject(new Error('Card photograph unavailable'));
          };
          const timer = setTimeout(() => finish(false), 12000); timers.add(timer);
          preload.onload = () => finish(preload.naturalWidth > 0);
          preload.onerror = () => finish(false);
          preload.sizes = image.sizes;
          preload.srcset = widths.map(w => sized(item.url,w)+' '+w+'w').join(', ');
          preload.src = sized(item.url,640);
          if (preload.complete && preload.naturalWidth) finish(true);
        });
        loads.set(item.url,pending);
        pending.catch(() => { if (loads.get(item.url) === pending) loads.delete(item.url); });
        return pending;
      };
      const warm = i => { if (i >= 0 && images[i] && !disposed) loadImage(images[i]).catch(() => {}); };
      const show = (requested, kind = 'manual', committed) => {
        const target = ((requested % images.length)+images.length)%images.length;
        const current = ++token; requestedIndex = target;
        if (feedback) feedback.textContent = '';
        if (target === index && image.complete && image.naturalWidth) {
          viewer.removeAttribute('aria-busy'); update(); if (kind !== 'native') syncNative(target); committed?.(); return;
        }
        viewer.setAttribute('aria-busy','true');
        loadImage(images[target]).then(preload => {
          if (disposed || !viewer.isConnected || current !== token) return;
          clearTransition();
          if (!nativeMode && !reducedMotion.matches && image.complete && image.naturalWidth) {
            transitionImage = document.createElement('span');
            transitionImage.className = 'ura-card-preview__outgoing';
            transitionImage.setAttribute('aria-hidden','true');
            const snapshot = image.cloneNode(false);
            snapshot.removeAttribute('srcset');
            snapshot.removeAttribute('id');
            snapshot.removeAttribute('data-card-primary');
            snapshot.src = image.currentSrc || image.src;
            snapshot.alt = '';
            transitionImage.appendChild(snapshot);
            stage.appendChild(transitionImage);
            const outgoing = transitionImage;
            transitionAnimation = outgoing.animate([{opacity:1},{opacity:0}],{duration:220,easing:'ease-out',fill:'forwards'});
            transitionAnimation.onfinish = () => { outgoing.remove(); if (transitionImage === outgoing) { transitionImage = null; transitionAnimation = null; } };
          }
          image.srcset = preload.srcset; image.src = preload.src;
          image.alt = images[target].alt || card.dataset.title || '';
          image.style.visibility = '';
          if (fallback) fallback.hidden = true;
          index = target; requestedIndex = target; viewer.removeAttribute('aria-busy'); update();
          if (kind !== 'native') syncNative(target);
          if (kind === 'manual' || kind === 'native') markColor(photoColor(images[target]),true);
          committed?.(); warm((index+1)%images.length);
        }).catch(() => {
          if (disposed || current !== token) return;
          requestedIndex = index; viewer.removeAttribute('aria-busy'); update(); syncNative(index);
          if (feedback && kind !== 'preview') feedback.textContent = viewer.dataset.cardLoadError || 'This photo could not load. Please try again.';
        });
      };
      const cancelPreview = () => {
        clearTimeout(hoverTimer); hoverTimer = 0;
        if (hoverOrigin !== null) { const origin = hoverOrigin; hoverOrigin = null; show(origin,'restore'); }
      };
      on(mobileInput,'change',() => { syncInput(); cancelPreview(); manualSession = false; });
      const takeControl = () => {
        clearTimeout(hoverTimer); hoverTimer = 0;
        if (hoverOrigin !== null) { ++token; requestedIndex = index; viewer.removeAttribute('aria-busy'); }
        hoverOrigin = null; manualSession = true;
      };
      const preview = (target, event) => {
        if (event.pointerType !== 'mouse' || !hoverInput.matches || mobileInput.matches || manualSession || target < 0 || target === index || requestedIndex !== index) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(() => {
          hoverTimer = 0;
          if (disposed || !card.isConnected || card.hidden || manualSession) return;
          hoverOrigin = index; show(target,'preview');
        }, reducedMotion.matches ? 0 : 280);
      };
      on(stage,'pointerenter',event => {
        if (event.pointerType === 'mouse') { touchInput = false; syncInput(); }
        const matchingBack = backIndex(selectedColor);
        preview(matchingBack >= 0 ? matchingBack : images.length > 1 ? 1 : -1,event);
      });
      on(stage,'pointerleave',event => {
        if (event.relatedTarget && controls.contains(event.relatedTarget)) return;
        cancelPreview();
      });
      on(card,'pointerleave',() => { if (!start) { cancelPreview(); manualSession = false; } });
      on(hoverInput,'change',() => { cancelPreview(); manualSession = false; });
      on(reducedMotion,'change',() => { clearTransition(); cancelPreview(); });
      on(link,'blur',cancelPreview);
      on(prev,'click',event => { event.preventDefault(); event.stopPropagation(); takeControl(); show(requestedIndex-1); });
      on(next,'click',event => { event.preventDefault(); event.stopPropagation(); takeControl(); show(requestedIndex+1); });
      on(link,'keydown',event => {
        if (images.length < 2 || event.altKey || event.ctrlKey || event.metaKey || !['ArrowRight','ArrowLeft','Home','End','Escape'].includes(event.key)) return;
        if (event.key === 'Escape') { cancelPreview(); return; }
        event.preventDefault(); takeControl();
        show(event.key === 'Home' ? 0 : event.key === 'End' ? images.length-1 : requestedIndex+(event.key === 'ArrowRight' ? 1 : -1)*direction);
      });
      let technologyHovered = false, technologyFocused = false, technologyTouch = false, technologyMultiTouch = false, technologyTimer = 0;
      const hideTechnology = () => {
        clearTimeout(technologyTimer); technologyTimer = 0;
        technologyHovered = false; technologyFocused = false; technologyTouch = false;
        viewer.removeAttribute('data-card-interacting');
        technology?.removeAttribute('data-card-tech-active');
        if (closeActiveTechnology === hideTechnology) closeActiveTechnology = null;
      };
      const revealTechnology = () => {
        if (!technology || disposed || technologyMultiTouch) return;
        clearTimeout(technologyTimer); technologyTimer = 0;
        if (closeActiveTechnology && closeActiveTechnology !== hideTechnology) closeActiveTechnology();
        closeActiveTechnology = hideTechnology;
        viewer.style.setProperty('--ura-card-tech-height',(technology.offsetHeight || 44)+'px');
        viewer.setAttribute('data-card-interacting','');
        technology.setAttribute('data-card-tech-active','');
      };
      const releaseTechnology = () => {
        technologyTouch = false;
        if (technologyHovered || technologyFocused) return;
        clearTimeout(technologyTimer);
        technologyTimer = setTimeout(hideTechnology,1200);
      };
      if (technology) {
        if (technologySlot) technologySlot.appendChild(technology);
        technology.hidden = false;
        technology.setAttribute('aria-hidden','true');
        viewer.setAttribute('data-card-has-technology','');
        on(stage,'pointerenter',event => {
          if (event.pointerType !== 'mouse' || !hoverInput.matches) return;
          technologyHovered = true; revealTechnology();
        });
        on(stage,'pointerleave',event => {
          if (controls.contains(event.relatedTarget)) return;
          technologyHovered = false;
          if (!technologyTouch && !technologyFocused) hideTechnology();
        });
        on(controls,'pointerenter',event => {
          if (event.pointerType !== 'mouse' || !hoverInput.matches) return;
          technologyHovered = true; revealTechnology();
        });
        on(controls,'pointerleave',event => {
          if (stage.contains(event.relatedTarget)) return;
          technologyHovered = false;
          if (!technologyTouch && !technologyFocused) hideTechnology();
        });
        on(stage,'pointerdown',event => {
          if (event.pointerType === 'mouse') return;
          if (event.isPrimary === false) { technologyMultiTouch = true; hideTechnology(); return; }
          technologyMultiTouch = false; technologyTouch = true; revealTechnology();
        },{capture:true,passive:true});
        on(stage,'touchstart',event => {
          if (event.touches.length !== 1) { technologyMultiTouch = true; hideTechnology(); return; }
          technologyMultiTouch = false; technologyTouch = true; revealTechnology();
        },{capture:true,passive:true});
        on(stage,'touchmove',event => {
          if (event.touches.length !== 1) { technologyMultiTouch = true; hideTechnology(); return; }
          if (!technologyMultiTouch) { technologyTouch = true; revealTechnology(); }
        },{capture:true,passive:true});
        on(stage,'touchend',event => {
          if (event.touches.length) return;
          const wasMultiTouch = technologyMultiTouch; technologyMultiTouch = false;
          if (wasMultiTouch) hideTechnology(); else releaseTechnology();
        },{capture:true,passive:true});
        on(stage,'touchcancel',() => { technologyMultiTouch = false; hideTechnology(); },{capture:true,passive:true});
        on(document,'pointerup',event => {
          if (event.pointerType !== 'mouse' && technologyTouch) { technologyMultiTouch = false; releaseTechnology(); }
        },{passive:true});
        const focusTechnology = () => {
          technologyFocused = link.matches(':focus-visible') || prev?.matches(':focus-visible') || next?.matches(':focus-visible');
          if (technologyFocused) revealTechnology();
        };
        [link,prev,next].forEach(node => {
          on(node,'focus',focusTechnology);
          on(node,'blur',event => {
            if ([link,prev,next].includes(event.relatedTarget)) return;
            technologyFocused = false;
            if (!technologyHovered && !technologyTouch) hideTechnology();
          });
        });
        on(document,'pointerdown',event => {
          if (!stage.contains(event.target) && !controls.contains(event.target)) hideTechnology();
        },{capture:true,passive:true});
        on(window,'resize',() => { if (viewer.hasAttribute('data-card-interacting')) viewer.style.setProperty('--ura-card-tech-height',(technology.offsetHeight || 44)+'px'); },{passive:true});
        on(document,'visibilitychange',() => { if (document.hidden) hideTechnology(); });
      }
      const mountNative = () => {
        const enabled = nativeTouchInput.matches && images.length > 1;
        if (enabled === nativeMode) return;
        nativeMode = enabled;
        if (!enabled) {
          nativeTrack?.remove(); nativeTrack = null; nativePhotos = []; nativeStart = null;
          viewer.removeAttribute('data-card-native'); return;
        }
        cancelPreview();
        nativeTrack = document.createElement('div');
        nativeTrack.className = 'ura-card-native-track';
        nativeTrack.dir = direction === -1 ? 'rtl' : 'ltr';
        nativeTrack.setAttribute('aria-hidden','true');
        nativeTrack.setAttribute('data-card-native-track','');
        nativePhotos = images.map((item,i) => {
          const slide = document.createElement('span'); slide.className = 'ura-card-native-slide';
          const photo = document.createElement('img'); photo.className = 'ura-card-native-image'; photo.alt = ''; photo.loading = 'lazy'; photo.decoding = 'async'; photo.draggable = false;
          const placeholder = document.createElement('span'); placeholder.className = 'ura-card-native-fallback'; placeholder.textContent = 'URA'; placeholder.hidden = true;
          on(photo,'load',() => { photo.hidden = false; placeholder.hidden = true; });
          on(photo,'error',() => {
            if (!photo.dataset.retried) {
              photo.dataset.retried = 'true'; photo.removeAttribute('srcset'); photo.src = sized(item.url,480); return;
            }
            photo.hidden = true; placeholder.hidden = false;
            if (i === requestedIndex && feedback) feedback.textContent = viewer.dataset.cardLoadError || 'This photo could not load. Please try again.';
          });
          slide.appendChild(photo); slide.appendChild(placeholder); nativeTrack.appendChild(slide); return photo;
        });
        ensureNative = target => {
          if (!nativeTrack) return;
          for (const i of [target-1,target,target+1]) {
            const photo = nativePhotos[i]; if (!photo || photo.dataset.loaded) continue;
            photo.dataset.loaded = 'true'; photo.sizes = image.sizes;
            photo.srcset = widths.map(w => sized(images[i].url,w)+' '+w+'w').join(', ');
            photo.src = sized(images[i].url,640);
          }
        };
        syncNative = target => {
          if (!nativeTrack) return;
          ensureNative(target);
          const left = target * nativeTrack.clientWidth * direction;
          if (Math.abs(nativeTrack.scrollLeft-left) > 1) nativeTrack.scrollTo({left,behavior:'auto'});
        };
        on(nativeTrack,'touchstart',event => {
          if (event.touches.length !== 1) { nativeStart = null; return; }
          takeControl(); suppressClickUntil = 0;
          nativeStart = {x:event.touches[0].clientX,y:event.touches[0].clientY};
        },{passive:true});
        on(nativeTrack,'touchmove',event => {
          if (!nativeStart || event.touches.length !== 1) return;
          const dx = event.touches[0].clientX-nativeStart.x, dy = event.touches[0].clientY-nativeStart.y;
          if (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy)) suppressClickUntil = Date.now()+700;
        },{passive:true});
        on(nativeTrack,'touchend',() => { nativeStart = null; },{passive:true});
        on(nativeTrack,'touchcancel',() => { nativeStart = null; },{passive:true});
        on(nativeTrack,'scroll',() => {
          if (nativeScrollFrame) return;
          nativeScrollFrame = requestAnimationFrame(() => {
            nativeScrollFrame = 0;
            if (!nativeTrack?.clientWidth || disposed) return;
            const target = Math.max(0,Math.min(images.length-1,Math.round(nativeTrack.scrollLeft*direction/nativeTrack.clientWidth)));
            ensureNative(target);
            if (target !== requestedIndex) { takeControl(); show(target,'native'); }
          });
        },{passive:true});
        stage.appendChild(nativeTrack);
        viewer.setAttribute('data-card-native','');
        syncNative(index);
      };
      on(nativeTouchInput,'change',mountNative);
      mountNative();
      const resetGesture = (cancelled = false) => {
        if (cancelled && start?.axis === 'x') suppressClickUntil = Date.now()+700;
        const id = start?.id;
        start = null;
        viewer.removeAttribute('data-card-dragging');
        image.style.removeProperty('translate');
        if (id !== undefined && stage.hasPointerCapture?.(id)) stage.releasePointerCapture(id);
      };
      const beginGesture = event => {
        if (nativeMode && event.pointerType !== 'mouse') return;
        if (event.isPrimary === false) { resetGesture(true); return; }
        if (event.button !== undefined && event.button !== 0) return;
        if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
        takeControl();
        suppressClickUntil = 0;
        touchInput = event.pointerType !== 'mouse'; syncInput();
        start = {x:event.clientX,y:event.clientY,id:event.pointerId,axis:null,time:performance.now(),width:stage.clientWidth,type:event.pointerType};
        viewer.removeAttribute('data-card-tech-dismissed');
        if (images.length > 1) warm((requestedIndex+1)%images.length);
      };
      const moveGesture = event => {
        if (!start || start.id !== event.pointerId) return;
        const dx = event.clientX-start.x, dy = event.clientY-start.y;
        if (!start.axis && Math.max(Math.abs(dx),Math.abs(dy)) > 12) {
          if (Math.abs(dx) > Math.abs(dy)*1.15) start.axis = 'x';
          else if (Math.abs(dy) > Math.abs(dx)) start.axis = 'y';
          if (start.axis === 'y') return;
          if (start.axis === 'x') {
            takeControl(); clearTransition();
            viewer.setAttribute('data-card-dragging','');
            try { stage.setPointerCapture(event.pointerId); } catch {}
          }
        }
        if (start.axis === 'x' && images.length > 1) {
          if (event.cancelable) event.preventDefault();
          suppressClickUntil = Date.now()+700;
        }
      };
      const endGesture = event => {
        if (!start || start.id !== event.pointerId) return;
        const dx = event.clientX-start.x, dy = event.clientY-start.y;
        const axis = start.axis || (Math.abs(dx) > 12 && Math.abs(dx) > Math.abs(dy)*1.15 ? 'x' : null);
        const elapsed = Math.max(1,performance.now()-start.time);
        const threshold = Math.max(22,Math.min(42,start.width*.12));
        resetGesture();
        if (axis !== 'x') return;
        if (images.length > 1) suppressClickUntil = Date.now()+700;
        if (images.length > 1 && (Math.abs(dx) >= threshold || (Math.abs(dx) >= 16 && Math.abs(dx)/elapsed > .35))) {
          takeControl(); show(requestedIndex+(dx < 0 ? 1 : -1)*direction);
        }
      };
      on(stage,'pointerdown',beginGesture);
      on(stage,'pointermove',moveGesture,{passive:false});
      on(stage,'pointerup',endGesture);
      on(document,'pointermove',moveGesture,{passive:false});
      on(document,'pointerup',endGesture);
      on(stage,'pointercancel',event => { resetGesture(true); if (!(nativeMode && event.pointerType === 'touch' && technologyTouch)) hideTechnology(); });
      on(stage,'lostpointercapture',event => { if (event.target === stage && start?.id === event.pointerId) resetGesture(true); });
      on(window,'blur',() => { resetGesture(true); hideTechnology(); });
      if (!('PointerEvent' in window) && !nativeTouchInput.matches) {
        const touchPointer = (touch,event) => ({clientX:touch.clientX,clientY:touch.clientY,pointerId:touch.identifier,pointerType:'touch',button:0,isPrimary:true,cancelable:event.cancelable,preventDefault:()=>event.preventDefault()});
        on(stage,'touchstart',event => {
          if (event.touches.length !== 1) { resetGesture(true); hideTechnology(); return; }
          beginGesture(touchPointer(event.touches[0],event));
        },{passive:true});
        on(stage,'touchmove',event => {
          if (event.touches.length !== 1) { resetGesture(true); hideTechnology(); return; }
          moveGesture(touchPointer(event.touches[0],event));
        },{passive:false});
        on(stage,'touchend',event => {
          const touch = [...event.changedTouches].find(t => t.identifier === start?.id);
          if (touch) endGesture(touchPointer(touch,event));
        });
        on(stage,'touchcancel',() => { resetGesture(true); hideTechnology(); });
      }
      on(link,'dragstart',event => event.preventDefault());
      image.draggable = false;
      const cardKey = () => new URL(link.href,location.href).pathname.split('/products/').pop();
      const remember = () => {
        try { sessionStorage.setItem('ura-shop-journey',JSON.stringify({shop:location.pathname+location.search,y:scrollY,handle:cardKey(),imageId:idKey(images[index].id),color:selectedColor,href:link.href,time:Date.now()})); } catch {}
      };
      on(link,'click',event => {
        if (event.detail !== 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && Date.now() < suppressClickUntil) { event.preventDefault(); event.stopImmediatePropagation(); suppressClickUntil = 0; return; }
        suppressClickUntil = 0; remember();
      },{capture:true});
      on(card.querySelector('h2 a'),'click',remember);
      swatches.forEach(swatch => {
        on(swatch,'pointerenter',event => { if (event.pointerType === 'mouse') warm(indexById(swatch.dataset.cardColorImage)); });
        on(swatch,'click',event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const target = indexById(swatch.dataset.cardColorImage);
          event.preventDefault(); event.stopPropagation();
          if (target < 0) { if (feedback) feedback.textContent = viewer.dataset.cardLoadError; return; }
          takeControl();
          show(target,'swatch',() => markColor(colorKey(swatch.dataset.cardColor),true));
        });
      });
      on(card.querySelector('[data-card-more-colors]'),'click',event => {
        const extra = [...card.querySelectorAll('[data-card-extra-color]')];
        extra.forEach(s => { s.hidden = false; });
        event.currentTarget.setAttribute('aria-expanded','true'); event.currentTarget.hidden = true;
        if (event.detail === 0) extra[0]?.focus({preventScroll:true});
      });
      const recoverImage = async () => {
        if (recovering || disposed) return;
        recovering = true;
        const current = ++token;
        viewer.setAttribute('aria-busy','true');
        image.style.visibility = 'hidden';
        if (fallback) fallback.hidden = false;
        for (const target of [index,...images.map((_,i) => i).filter(i => i !== index)]) {
          try {
            const preload = await loadImage(images[target]);
            if (disposed || current !== token) break;
            image.srcset = preload.srcset; image.src = preload.src;
            image.alt = images[target].alt || card.dataset.title || '';
            image.style.visibility = '';
            if (fallback) fallback.hidden = true;
            index = target; requestedIndex = target;
            markColor(photoColor(images[target]),true); update(); syncNative(target);
            if (feedback) feedback.textContent = '';
            break;
          } catch {}
          if (disposed || current !== token) break;
        }
        if (!disposed && current === token) {
          viewer.removeAttribute('aria-busy');
          if (image.style.visibility === 'hidden' && feedback) feedback.textContent = viewer.dataset.cardLoadError || 'This photo could not load. Please try again.';
        }
        recovering = false;
      };
      on(image,'error',recoverImage);
      markColor(selectedColor,true); update(); viewer.dataset.ready = 'true';
      if (image.complete && !image.naturalWidth) recoverImage();
      let saved;
      try { saved = JSON.parse(sessionStorage.getItem('ura-shop-journey') || 'null'); } catch {}
      if (card.hasAttribute('data-ura2-card') && saved && saved.shop === location.pathname+location.search && saved.handle === cardKey() && Date.now()-saved.time < 1800000) {
        const restore = indexById(saved.imageId);
        if (restore >= 0) show(restore,'restore',() => {
          markColor(colorKey(saved.color) || photoColor(images[restore]));
          if (saved.href) {
            try {
              const destination = new URL(saved.href,location.href);
              if (destination.origin === location.origin && destination.pathname.split('/products/').pop() === cardKey()) {
                [link,card.querySelector('h2 a')].filter(Boolean).forEach(a => { a.href = destination.href; });
              }
            } catch {}
          }
        });
        if (Number.isFinite(saved.y)) requestAnimationFrame(() => requestAnimationFrame(() => { if (viewer.isConnected) scrollTo({top:saved.y,behavior:'auto'}); }));
      }
      let observer;
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(entries => {
          if (entries.some(e => e.isIntersecting)) { ensureNative(index); warm(backIndex(selectedColor)); warm((index+1)%images.length); }
          else cancelPreview();
        },{rootMargin:'200px'});
        observer.observe(viewer);
      }
      const destroy = () => {
        disposed = true; resetGesture(true); hideTechnology(); if (technology) { technology.hidden = true; stage.appendChild(technology); } viewer.removeAttribute('data-card-has-technology'); viewer.style.removeProperty('--ura-card-tech-height'); nativeTrack?.remove(); nativeTrack = null; viewer.removeAttribute('data-card-native'); clearTransition(); ++token; clearTimeout(hoverTimer); timers.forEach(clearTimeout);
        viewer.removeAttribute('aria-busy');
        viewer.removeAttribute('data-card-swipe-only'); sizeObserver?.disconnect();
        indicator.remove(); help.remove();
        if (originalDescription === null) link.removeAttribute('aria-describedby');
        else link.setAttribute('aria-describedby',originalDescription);
        [prev,next].forEach((button,i) => {
          if (!button) return;
          if (originalTabStops[i] === null) button.removeAttribute('tabindex');
          else button.setAttribute('tabindex',originalTabStops[i]);
        });
        abort.abort(); image.style.removeProperty('translate'); observer?.disconnect(); cardViewerInstances.delete(viewer);
      };
      cardViewerInstances.set(viewer,destroy);
    });
  };

  window.URACardViewers = {mount:initCardViewers};
  const boot = () => initCardViewers(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();
  document.addEventListener('shopify:section:load',boot);
  if ('MutationObserver' in window) {
    let mountFrame = 0;
    new MutationObserver(records => {
      const changed = records.some(record => [...record.addedNodes,...record.removedNodes].some(node => node.nodeType === 1 && (node.matches?.('[data-card-viewer]') || node.querySelector?.('[data-card-viewer]'))));
      if (!changed || mountFrame) return;
      mountFrame = requestAnimationFrame(() => { mountFrame = 0; boot(); });
    }).observe(document.documentElement,{childList:true,subtree:true});
  }
  document.addEventListener('shopify:section:unload',event => {
    cardViewerInstances.forEach((destroy,node) => { if (event.target.contains(node)) destroy(); });
  });
})();


